export default __webpack_public_path__ + "static/media/hamburger.a46d5c1c.svg";